import { MessageCircle, Paintbrush, Droplet, Gift } from "lucide-react";
import Mashobg from "../../assets/images/Masho_making 1.jpg"



export default function MashoStudioPage() {
  // WhatsApp link with pre-filled message
  const whatsappNumber = "917025959481"; // Corrected phone number format
  const whatsappMessage = encodeURIComponent(
    "Hi, I’d like to customize a perfume bottle for a gift!"
  );
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  // Customization steps data
  const customizationSteps = [
    {
      icon: <Paintbrush className="h-8 w-8 text-[#D4AF37]" />,
      title: "Choose Your Bottle Design",
      description: "Select from a variety of elegant bottle shapes and finishes to match your style or the recipient's taste.",
    },
    {
      icon: <Droplet className="h-8 w-8 text-[#D4AF37]" />,
      title: "Select Your Fragrance",
      description: "Pick a signature scent from our luxurious fragrance notes—floral, woody, citrus, or oriental.",
    },
    {
      icon: <Gift className="h-8 w-8 text-[#D4AF37]" />,
      title: "Personalize the Packaging",
      description: "Add a personal touch with custom engravings, gift wrapping, and a heartfelt message.",
    },
  ];

  return (
    <>
      {/* Inline CSS for animations */}
      <style>
        {`
          @keyframes fadeInUp {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          .animate-fadeInUp {
            animation: fadeInUp 1s ease-out forwards;
          }
        `}
      </style>

      <div className="bg-gradient-to-b from-gray-50 to-white dark:from-[#121212] dark:to-[#1a1a1a]">
        {/* Hero Section */}
        <section className="relative w-full h-[70vh] md:h-[90vh] flex items-center justify-center text-center px-4 md:px-8">
          <div className="absolute inset-0">
            <img
              src= {Mashobg}
              alt="Custom Perfume Bottle"
              className="w-full blur-sm h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
          </div>
          <div className="relative z-10 animate-fadeInUp">
            <h1
              className=" text-4xl md:text-6xl text-white mb-4 tracking-wide"
              style={{ fontFamily: ", serif" }}
            >
              Create Your Signature Scent
            </h1>
            <p className="text-base md:text-xl text-gray-200 dark:text-gray-100 max-w-3xl mx-auto mb-6">
              Welcome to Masho Studio — a space where your imagination meets our expertise. Select your notes, adjust the balance, and personalize every detail to design a perfume that’s truly yours.
            </p>
          </div>
        </section>

        {/* Customization Process Section */}
        <section className="py-12 px-4 md:px-8 max-w-7xl mx-auto">
          <div className="text-center mb-12 animate-fadeInUp">
            <h2
              className=" text-2xl md:text-4xl text-[#333333] dark:text-white mb-2 tracking-wide"
              style={{ fontFamily: ", serif" }}
            >
              How It Works
            </h2>
            <p className="text-sm md:text-base text-gray-500 dark:text-gray-300 max-w-md mx-auto">
              Follow these simple steps to create your custom perfume bottle.
            </p>
            <div className="mt-4 h-1 w-20 bg-[#D4AF37] mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {customizationSteps.map((step, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center animate-fadeInUp"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="mb-4">{step.icon}</div>
                <h3
                  className=" text-lg md:text-xl text-[#333333] dark:text-white mb-2"
                  style={{ fontFamily: "serif" }}
                >
                  {step.title}
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-300 max-w-xs">{step.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Final Call-to-Action Section */}
        <section className="py-12 px-4 md:px-8 bg-gradient-to-r from-[#D4AF37]/10 to-transparent dark:from-[#D4AF37]/20 dark:to-transparent">
          <div className="max-w-7xl mx-auto text-center animate-fadeInUp">
            <h2
              className=" text-2xl md:text-4xl text-[#333333] dark:text-white mb-4 tracking-wide"
            >
              Ready to Create Your Perfume Bottle
            </h2>
            <p className="text-sm md:text-base text-gray-500 dark:text-gray-300 max-w-xl mx-auto mb-6">
              Connect with our team on WhatsApp to start designing your custom perfume bottle today. Let’s make it unforgettable.
            </p>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex w-72 items-center gap-2 bg-[#D4AF37] text-black px-3 py-3 rounded-sm text-sm font-medium hover:bg-[#C19B2E] transition-all duration-200 transform hover:scale-105 shadow-md hover:shadow-lg mx-auto"
            >
              <MessageCircle className="h-4 w-4" />
              Customize Now
            </a>
          </div>
        </section>
      </div>
    </>
  );
}